import { forwardRef, useImperativeHandle, useRef, useState, useEffect, useContext } from "react";
import { Unity, useUnityContext } from "react-unity-webgl";
import { AppContext } from "./AppContext";

const Game = forwardRef((props, ref) => {
  /*   const { unityProvider, sendMessage } = useUnityContext({
      loaderUrl: "build/halloween.loader.js",
      dataUrl: "build/halloween.data",
      frameworkUrl: "build/halloween.framework.js",
      codeUrl: "build/halloween.wasm",
    }); */

  const { unityProvider, sendMessage, addEventListener, removeEventListener } = useUnityContext({
    loaderUrl: "build/halloween.loader.js",
    dataUrl: "build/halloween.data.unityweb",
    frameworkUrl: "build/halloween.framework.js.unityweb",
    codeUrl: "build/halloween.wasm.unityweb"
  });

  const [devicePixelRatio, setDevicePixelRatio] = useState(window.devicePixelRatio);
  const { canvasRef, isOpen, lockPointer, unlockPointer, setIsLoaded } = useContext(AppContext);

  useEffect(() => {
    const updateDevicePixelRatio = () => {
      setDevicePixelRatio(window.devicePixelRatio);
    };
    const mediaMatcher = window.matchMedia(`screen and (resolution: ${devicePixelRatio}dppx)`);

    mediaMatcher.addEventListener("change", updateDevicePixelRatio);
    return () => {
      mediaMatcher.removeEventListener("change", updateDevicePixelRatio);
    };
  }, [devicePixelRatio]);

  useEffect(() => {
    const handleLoading = () => {
      setIsLoaded(true);
      lockPointer();
    };

    const handleLockCursor = () => {
      lockPointer();
    };

    const handleUnlockCursor = () => {
      unlockPointer();
    };

    const handleDialogue = (d) => {
      props.updateIsDialogue(d);
    };

    const handleSendMaskName = (name) => {
      props.setMask(name);
    };

    const handleEndGame = () => {
      props.showMint();
      unlockPointer();
    };

    // Events from Unity
    addEventListener("SetLoadedState", handleLoading);
    addEventListener("LockCursor", handleLockCursor);
    addEventListener("UnlockCursor", handleUnlockCursor);
    addEventListener("SetIsDialogue", handleDialogue);
    addEventListener("SendMaskName", handleSendMaskName);
    addEventListener("EndGame", handleEndGame);
    return () => {
      removeEventListener("SetLoadedState", handleLoading);
      removeEventListener("LockCursor", handleLockCursor);
      removeEventListener("UnlockCursor", handleUnlockCursor);
      removeEventListener("SetIsDialogue", handleDialogue);
      removeEventListener("SendMaskName", handleSendMaskName);
      removeEventListener("EndGame", handleEndGame);
    };
  });

  useImperativeHandle(ref, () => ({
    freezeCamera() {
      sendMessage("GameManager", "FreezeCamera");
    },
    unfreezeCamera() {
      sendMessage("GameManager", "UnfreezeCamera");
    }
  }));

  return (
    <div>
      <Unity
        unityProvider={unityProvider}
        className="fixed h-full w-full"
        devicePixelRatio={devicePixelRatio}
        ref={canvasRef}
      />
    </div>
  );
});

export default Game;
